import { handleApiGet, handleApiPut } from "./api";
import { BackendUrl } from "./newBackendApi";

import { ISource } from "../interfaces";

const adType = "ad-banner";
export enum definedAdTypes {
  big = "ad-big",
  small = "ad-small",
  text = "ad-text",
}

export interface IAd {
  slug: definedAdTypes;
  type: typeof adType;
  source?: ISource;
  imageUrl?: string;
  links: Array<ISource>;
  imagePointer?: File;
}

export async function getAd(slug: definedAdTypes) {
  return handleApiGet(`${BackendUrl}/get-item/ad/${encodeURIComponent(slug)}`);
}

export function postAd(
  idToken: string,
  slug: definedAdTypes,
  body: Pick<IAd, "imageUrl" | "links" | "source">,
) {
  return handleApiPut(
    `${BackendUrl}/admin/put-item/ad/${encodeURIComponent(slug)}`,
    idToken,
    body,
  );
}
